export function resolveMyTaskCreationAssigneeIds(
    assigneeIds: unknown,
    currentUserId: string | number | null | undefined,
) {
    if (Array.isArray(assigneeIds) && assigneeIds.length > 0) {
        return assigneeIds
    }

    return currentUserId == null || String(currentUserId) === ''
        ? []
        : [currentUserId]
}

export function mergeMyTaskDetails(summary: any, details: any, projectTask: any) {
    const mergedTask = {
        ...summary,
        ...(projectTask || {}),
        ...(details || {}),
    }
    const relatedTasks = projectTask?.relatedTasks
        ?? details?.relatedTasks
        ?? summary?.relatedTasks

    return relatedTasks === undefined
        ? mergedTask
        : { ...mergedTask, relatedTasks }
}
